import { render } from "./shopSettings.vue?vue&type=template&id=3511bc18&scoped=true"
import script from "./shopSettings.vue?vue&type=script&lang=js"
export * from "./shopSettings.vue?vue&type=script&lang=js"

import "./shopSettings.vue?vue&type=style&index=0&id=3511bc18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3511bc18"]])

export default __exports__